/**
 * 通用拼接URL
 * @param {*} serviceName
 * @param {*} controllerName
 * @param {*} interfaceName
 */
export function getUrlByGeneralInYinyitong(serviceName, controllerName, interfaceName) {
  return '/' + serviceName + '/services/' + controllerName + '/' + interfaceName;
}

/**
 * 通用拼接URL
 * @param {*} serviceName
 * @param {*} controllerName
 * @param {*} interfaceName
 */
export function getUrlByGeneral(serviceName, controllerName, interfaceName) {
  return '/' + serviceName + '/api/' + controllerName + '/' + interfaceName;
}
